import { useMemo } from "react";

import type { LocationType } from "@/pages/search/types";

import Games from "../games";
import LocationTile from "./location-tile";

interface LocationsProps {
  locations: LocationType[];
  onHover(locationId: string | null): void;
}

export default function Locations({ locations, onHover }: LocationsProps) {
  const handleMouseEnter = (location: LocationType) => () =>
    onHover(location.id);

  const handleMouseLeave = () => onHover(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: its okay
  const renderLocations = useMemo(() => {
    let startIndex = 1;
    const tiles: React.ReactNode[] = [];

    for (const location of locations) {
      if (location.games?.length) {
        tiles.push(
          // biome-ignore lint/a11y/noStaticElementInteractions: yeah its ok
          // biome-ignore lint/a11y/noNoninteractiveElementInteractions: legacy
          <div
            key={location.id}
            onMouseEnter={handleMouseEnter(location)}
            onMouseLeave={handleMouseLeave}
          >
            <LocationTile location={location} />
            <Games
              games={location.games}
              startIndex={startIndex}
              withoutCompany
              withoutLocation
            />
          </div>
        );
      }
      startIndex += location.games?.length || 0;
    }

    return tiles;
  }, [locations]);

  return (
    <div className="flex flex-col items-stretch pt-2.5 *:not-first:mt-2.5 *:not-first:border-white/8 *:not-first:border-t *:not-first:pt-2.5 md:pt-6 *:not-first:md:mt-6.5 *:not-first:md:border-0 *:not-first:md:pt-6.5">
      {renderLocations}
    </div>
  );
}
